var _path, _rect, _path2, _line, _line2, _line3, _rect2, _circle, _circle2, _path3, _path4, _rect3, _rect4, _line4, _line5, _line6, _line7, _path5, _path6, _path7, _path8, _line8, _rect5, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCategoriesIcon = function SvgCategoriesIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 55V49H43",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10.4469,
    width: 34,
    height: 47,
    transform: "rotate(-15 14 10.4469)",
    fill: "#F6F8F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2864 32.1963L24.9306 47.3762L27.1305 55.5866C27.4164 56.6535 28.5131 57.2867 29.58 57.0008L60.0067 48.848C61.0736 48.5621 61.7068 47.4655 61.4209 46.3985L60.1993 41.8394C60.0694 41.3549 59.7623 40.9368 59.3387 40.6681L45.654 31.9883L42.472 37.4996L33.2864 32.1963Z",
    fill: "#A5CC9B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.7774,
    y1: 16.9496,
    x2: 30.3004,
    y2: 13.3261,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8834,
    y1: 28.5407,
    x2: 24.713,
    y2: 27.2466,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27.9898,
    y1: 20.1569,
    x2: 34.7513,
    y2: 18.3452,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10.4469,
    width: 34,
    height: 47,
    transform: "rotate(-15 14 10.4469)",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.3169,
    cy: 20.9402,
    r: 3.5,
    transform: "rotate(-15 46.3169 20.9402)",
    fill: "#F7D687"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.8677,
    cy: 19.526,
    r: 3.5,
    transform: "rotate(-15 43.8677 19.526)",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9291 43.7713L30.5778 29.8162L44.1794 38.0773",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8063 38.8352L43.2047 30.574L40.4232 35.6488",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6821,
    y: 13,
    width: 34,
    height: 47,
    transform: "rotate(15 51.6821 13)",
    fill: "#F6F8F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7803,
    y: 46.6179,
    width: 33,
    height: 15,
    rx: 2,
    transform: "rotate(15 45.7803 46.6179)",
    fill: "#93D8ED"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 43.3307,
    y1: 48.0322,
    x2: 53.9559,
    y2: 50.8792,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 58.7853,
    y1: 52.1732,
    x2: 70.3764,
    y2: 55.2791,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 47.8322,
    y1: 54.4147,
    x2: 60.3892,
    y2: 57.7793,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 64.2526,
    y1: 58.8146,
    x2: 66.1844,
    y2: 59.3323,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7892 41.3586C61.5884 40.5009 58.2984 42.4004 57.4407 45.6012L69.0318 48.7071C69.8895 45.5063 67.99 42.2162 64.7892 41.3586Z",
    fill: "#F7D687"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1339 47.9306C66.9915 44.7298 65.0921 41.4398 61.8913 40.5822C58.6905 39.7245 55.4004 41.624 54.5428 44.8248",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.37 31.5513C52.7126 31.0483 55.5064 30.7962 55.9408 33.8113C57.0046 33.0611 59.5115 32.0764 61.0293 34.1395",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1347 28.0818C63.4773 27.5788 66.2711 27.3266 66.7055 30.3418C67.7692 29.5916 70.2762 28.6069 71.7939 30.67",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 44.8834,
    y1: 42.2366,
    x2: 75.7931,
    y2: 50.5188,
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6821,
    y: 13,
    width: 34,
    height: 47,
    transform: "rotate(15 51.6821 13)",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1304 41L45.7826 55.1867H82V97H14V41H39.1304Z",
    fill: "#F6F8F9",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6701 46.1509L47.2429 58.0358C47.5723 58.7381 48.278 59.1867 49.0538 59.1867H84C85.1046 59.1867 86 60.0821 86 61.1867V99C86 100.105 85.1046 101 84 101H20C18.8954 101 18 100.105 18 99V47C18 45.8954 18.8954 45 20 45H39.8593C40.635 45 41.3408 45.4486 41.6701 46.1509Z",
    fill: "#F7D687"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1304 41L45.7826 55.1867H82V97H14V41H39.1304Z",
    stroke: "#2A5969",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCategoriesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "a516c52f86dbdc2978669be9156c24b7.svg";